export default __webpack_public_path__ + "static/media/checkmark.95a347aa.svg";